import { isValidAddress } from "xrpl";

import { XRPL } from "./utils/enums";

type Validators = {
  validateVerifierId: (selectedTypeOfLogin: string, value: string) => boolean;
};
const useCustomValidators = (): Validators => {
  const validateVerifierId = (selectedTypeOfLogin: string, value: string) => {
    // eslint-disable-next-line no-console
    console.log("selectedTypeOfLogin", selectedTypeOfLogin, value);
    if (selectedTypeOfLogin === XRPL) {
      return isValidAddress(value);
    }

    return true;
  };
  return {
    validateVerifierId,
  };
};

export default useCustomValidators;
